import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-08/task-01";

const task: Slide = {
  titleHtml: `Which frequencies are proper frequencies of these tubes<br>(c = 340 m/s, L = 85 cm, no length correction considered)?`,
  description: "Select the correct answers.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
